import { useContext } from 'react'
import LoadingContext from 'src/context/LoadingContext'
import { LoadingContextType } from 'src/@types/loading'
export const useLoading = () => {
    const { loading, setLoading } = useContext(LoadingContext) as LoadingContextType
    return [loading, setLoading]
}

export default LoadingContext
